import type { MessageCustomType } from './chat.types';

export class CustomTypeList {
  private items: MessageCustomType[];

  private constructor(initial: Iterable<MessageCustomType> = []) {
    this.items = Array.from(initial);
  }

  static fromString(value?: string) {
    const parts = (value ?? '')
      .split(',')
      .map((item) => item.trim())
      .filter((item) => item !== '') as MessageCustomType[];
    return new CustomTypeList(parts);
  }

  add(type: MessageCustomType) {
    if (!this.items.includes(type)) this.items.push(type);
    return this;
  }

  remove(type: MessageCustomType) {
    this.items = this.items.filter((item) => item !== type);
    return this;
  }

  has(type: MessageCustomType) {
    return this.items.includes(type);
  }

  get types(): MessageCustomType[] {
    return this.items;
  }
}

export function getCustomTypes(message: { customType?: string }) {
  return CustomTypeList.fromString(message.customType);
}
